"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateNewDialog = void 0;
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const styles_1 = require("../../../styles");
const CreateNewDialog = ({ title, children, onClose, onSubmit, isSubmitting, cancelText = 'Cancel', submitText = 'Create', dialogClasses, }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: dialogClasses === null || dialogClasses === void 0 ? void 0 : dialogClasses.wrapper },
        react_1.default.createElement(core_1.Box, { className: `${classes.header} ${(_a = dialogClasses === null || dialogClasses === void 0 ? void 0 : dialogClasses.header) !== null && _a !== void 0 ? _a : ''}` },
            react_1.default.createElement(core_1.DialogTitle, null, title),
            react_1.default.createElement(core_1.IconButton, { onClick: onClose, className: `${classes.closeBtn} ${(_b = dialogClasses === null || dialogClasses === void 0 ? void 0 : dialogClasses.closeButton) !== null && _b !== void 0 ? _b : ''}` },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faClose }))),
        react_1.default.createElement(core_1.Divider, null),
        react_1.default.createElement(core_1.DialogContent, { className: `${classes.body} ${(_c = dialogClasses === null || dialogClasses === void 0 ? void 0 : dialogClasses.content) !== null && _c !== void 0 ? _c : ''}` }, children),
        react_1.default.createElement(core_1.DialogActions, { className: classes.footer },
            react_1.default.createElement(core_1.Button, { variant: "outlined", color: "primary", className: `${classes.button} ${classes.cancelButton} ${(_d = dialogClasses === null || dialogClasses === void 0 ? void 0 : dialogClasses.button) !== null && _d !== void 0 ? _d : ''} ${(_e = dialogClasses === null || dialogClasses === void 0 ? void 0 : dialogClasses.cancelButton) !== null && _e !== void 0 ? _e : ''}`, onClick: onClose }, cancelText),
            react_1.default.createElement(core_1.Button, { variant: "contained", color: "primary", className: `${classes.button} ${classes.submitButton} ${(_f = dialogClasses === null || dialogClasses === void 0 ? void 0 : dialogClasses.button) !== null && _f !== void 0 ? _f : ''} ${(_g = dialogClasses === null || dialogClasses === void 0 ? void 0 : dialogClasses.submitButton) !== null && _g !== void 0 ? _g : ''}`, onClick: onSubmit, disabled: isSubmitting }, submitText))));
};
exports.CreateNewDialog = CreateNewDialog;
const useStyles = (0, core_1.makeStyles)(theme => ({
    body: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '30px 35px',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
    },
    header: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        padding: '20px 20px 17px 32px',
        height: 57,
        backgroundColor: theme.palette.background.paper,
        '& .MuiDialogTitle-root': {
            padding: 0,
        },
        '& .MuiDialogTitle-root .MuiTypography-h6': {
            color: theme.palette.text.primary,
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '100%',
        },
    },
    closeBtn: {
        position: 'absolute',
        right: 20,
        '& .MuiIconButton-root': {
            padding: 0,
        },
        height: 32,
        width: 32,
        color: theme.palette.primary.main,
    },
    footer: {
        boxShadow: `0px -2px 4px 0px ${theme.palette.action.disabledBackground}`,
        padding: '17.5px 20px',
        backgroundColor: theme.palette.background.paper,
    },
    button: {
        fontSize: 16,
        fontWeight: 500,
        height: 42,
        color: theme.palette.text.primary,
    },
    cancelButton: {
        color: theme.palette.primary.main,
        width: 134,
    },
    submitButton: {
        marginLeft: '15px !important',
        width: 144,
        color: styles_1.colors.white,
    },
}));
exports.default = exports.CreateNewDialog;
//# sourceMappingURL=CreateNewDialog.js.map